import RouteConfig from './config/RouteConfig';
import RenewalService from './services/RenewalService';

export default angular.module('edge.renewal.app', []).factory('transaction.RenewalService', RenewalService).config(['$stateProvider', 'state_plugin_config', function ($stateProvider, RootStateConfig) {
    var states = new RouteConfig(RootStateConfig);
    for (var stateName in states) {
        if (states.hasOwnProperty(stateName)) {
            $stateProvider.state(stateName, states[stateName]);
        }
    }
}]);


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-renewal-angular/module.js
// module id = 1873
// module chunks = 0